import { Box, Image, Text } from '@chakra-ui/react'
import { useTranslation } from 'next-i18next'
import { useEngraving } from 'modules/cart/hooks/useEngraving'
import { engravingFileName } from 'modules/product/utils/engraveOptionName'
import { useDimensions } from 'modules/cart/hooks/useDimensions'

interface Props
  extends Pick<
    ReturnType<typeof useEngraving>,
    'selectedEngraveOptionsArray' | 'activePendantId' | 'activeSide'
  > {
  sku?: string;
}

export const EngravingGraphic = ({
  selectedEngraveOptionsArray,
  activePendantId,
  activeSide,
  sku,
}: Props) => {
  const { t } = useTranslation('engraving')
  const { width, height, left, top } = useDimensions(sku, activeSide)

  const activeSelectedOption = selectedEngraveOptionsArray.find(
    option =>
      option.pendant_idx?.toString() === activePendantId &&
      option.placement === activeSide
  )

  const engravingImage =
    activeSelectedOption?.code === 'graw_masz_spec_2'
      ? activeSelectedOption.file
      : ''

  const alt = engravingFileName(activeSelectedOption)

  if (!engravingImage) return null

  return (
    <>
      <Box
        width={`${width}%`}
        height={`${height}%`}
        top={`${top}%`}
        left={`${left}%`}
        position="absolute"
        zIndex={9}
      >
        <Image
          src={engravingImage}
          alt={t(alt)}
          objectFit="contain"
          height="100%"
          width="100%"
        />
      </Box>
      <Text
        position="absolute"
        top="100%"
        mt={2}
        w="100%"
        textAlign="center"
        fontSize="xs"
        px={{ base: 4, lg: 0 }}
      >
        {t('ILLUSTRATIVE_PHOTO')}
        <br />
        {t('WE_WILL_DO_OUR_BEST')}
      </Text>
    </>
  )
}
